module.exports = __webpack_public_path__ + "img/dlylogo01.cf1787a0.png";